export default class Verivox
{
    // Not used atm
    getFaqAnswer(faqId) {
        return $.ajax({
            url: window.location.origin + window.APP.config.appPath + window.Router.routes['ajax-stromanbieterwechsel-faq'],
            type: 'POST',
            data: {
                vxcp_FAQID: faqId,
            }
        });
    }

    getLocationByPlz(plz, type) {
        return $.ajax({
            url: window.location.origin + window.APP.config.appPath + window.Router.routes[`ajax-plz-check-${type}`],
            type: 'POST',
            data: { plz }
        });
    }

    getProviderInfo(carrierData, type) {
        return $.ajax({
            url: `/ajax/providerInfo/${type}`,
            data: carrierData
        });
    }

    getTariffCheck(tariffData) {
        return $.ajax({
            url: "/ajax/tariff-check",
            data: tariffData
        });
    }

    getTarifvergleichData(formData, type, route, $callback, $callbackError) {
        let options = {
            url: route,
            type: 'POST',
            data: {
                formData,
                type
            }
        };

        return $.ajax(options).done($callback).fail($callbackError);
    }

    getQueryString(field, url) {
        let href = url ? url : window.location.href;
        let reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
        let string = reg.exec(href);

        return string ? string[1] : null;
    }

    prepareNewContent(result) {
        let html = $(result.results).find('#vxcp_power-calculator-result_table').html();

        if ($('.result-column #vxcp_power-calculator-result_table').length < 1) {
            $('.callout').remove();

            $('.result-column').append(result.results);
            $('.result-column tr.vxcp_tr-savings-yes').addClass('vxcp_has-result-detail');

            $('.please-wait').fadeOut();
            $('.result-column').removeClass('refresh');

            return;
        }

        $('.result-column #vxcp_power-calculator-result_table').html(html);
        $('.result-column #vxcp_power-calculator-result_table tbody tr').each(function () {
            if ($('.vxcp_get-result-detail').length > 0) {
                $(this).addClass('vxcp_has-result-detail');
            }
        });

        let pagination = $(result.results).find('.vxcp_pagination ').html();

        return $('.result-column').find('.vxcp_pagination ').html(pagination);
    }
}
